import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import Select from 'react-select'
import {useThemeMode} from '../../../../_metronic/partials'
import {useDropzone} from 'react-dropzone'

const options = [
  {value: 'option one', label: 'option one'},
  {value: 'option two', label: 'option two'},
  {value: 'option three', label: 'option three'},
]

const priorityOptions = [
  {value: 'High', label: 'High'},
  {value: 'Medium', label: 'Medium'},
  {value: 'Low', label: 'Low'},
]

const NewDepartmentModal = () => {
  return (
    <div className='modal fade' tabIndex={-2} id='kt_modal_2'>
      <div className='modal-dialog modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Add New Department</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form>
              <div className='row mb-4'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span className='required'>Department Name</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='departmentName'
                    placeholder='Enter Department Name<'
                    className='form-control form-control-lg form-control-solid'
                    required
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fs-6'>Description</label>
                <div className='col-lg-8 fv-row-3'>
                  <textarea
                    name='description'
                    placeholder='Enter Description..'
                    className='form-control form-control-lg form-control-solid'
                    rows={5}
                    style={{resize: 'vertical', fontSize: '1.0rem'}}
                    required
                  ></textarea>
                </div>
              </div>

              <div className='row mb-4'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span className='required'>Email</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='email'
                    placeholder='Enter Email Address'
                    className='form-control form-control-lg form-control-solid'
                    required
                  />
                </div>
              </div>

              <div className='row mb-4'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span className='required'>Assinged Admin Users</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <div className='form-check mb-6'>
                    <input className='form-check-input' type='checkbox' value='' />
                    <label className='form-check-label'>hasan (Muhammad Hasan)</label>
                  </div>
                  <div className='form-check mb-6'>
                    <input className='form-check-input' type='checkbox' value='' />
                    <label className='form-check-label'>riyadHossain (Riyad Hossain)</label>
                  </div>
                  <div className='form-check mb-6'>
                    <input className='form-check-input' type='checkbox' value='' />
                    <label className='form-check-label'>saki (Nazmul Haque Saki)</label>
                  </div>
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Clients Only</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <div className='form-check form-switch form-check-custom form-check-solid'>
                    <input name='clientsOnly' className='form-check-input' type='checkbox' />
                  </div>
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Pipe Replies Only</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <div className='form-check form-switch form-check-custom form-check-solid'>
                    <input name='pipeRepliesOnly' className='form-check-input' type='checkbox' />
                  </div>
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>No Autoresponder</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <div className='form-check form-switch form-check-custom form-check-solid'>
                    <input name='autoresponder' className='form-check-input' type='checkbox' />
                  </div>
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Feedback Request</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <div className='form-check form-switch form-check-custom form-check-solid'>
                    <input name='feedbackRequest' className='form-check-input' type='checkbox' />
                  </div>
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Hidden</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <div className='form-check form-switch form-check-custom form-check-solid'>
                    <input name='hidden' className='form-check-input' type='checkbox' />
                  </div>
                </div>
              </div>

              <h4 className='mb-8 mt-10 text-gray-800'>
                Mail Importing Configuration (Only required if using POP Cron import method)
              </h4>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Hostname</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='hostname'
                    placeholder='Enter Hostname'
                    className='form-control form-control-lg form-control-solid'
                    required
                  />
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Mail Server Port</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='mailServerPort'
                    placeholder='Enter Mail Server Port'
                    className='form-control form-control-lg form-control-solid'
                    required
                  />
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Email Address</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='mailEmail'
                    placeholder='Enter Mail Email Address'
                    className='form-control form-control-lg form-control-solid'
                    required
                  />
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Email Pass</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='mailEmailPass'
                    placeholder='Enter Mail Email Pass'
                    className='form-control form-control-lg form-control-solid'
                    required
                  />
                </div>
              </div>

              <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'></label>

                <div className='col-lg-8 fv-row'>
                  <button type='button' className='btn btn-secondary'>
                    Test Configuration
                  </button>
                </div>
              </div>

              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  className='btn btn-light me-4'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Close
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Add Department
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewDepartmentModal
